import { CompanyCreationDocumentType } from '__generated__/GQL';
import getIdentityStatus from 'features/Onboarding/modules/Identity/libs/getIdentityStatus';

import { State } from '../../machine';
import model from '../../machine/model';
import { getCreationDocumentStatus } from '../getCreationDocumentStatus';
import locales from './locales';
import { GetVerificationStep, VerificationStatus } from './types';

const getPowerOfAttorneyStep: GetVerificationStep = (context) => {
  const idStatus = getIdentityStatus({
    companyUser: context.verificationData.viewer.companyUser,
  });

  const verificationRequired = idStatus === VerificationStatus.ToDo;
  const hasSignedDocument = sessionStorage.getItem(
    `hasSigned:${context.verificationData.viewer.company.applicationId}:${CompanyCreationDocumentType.PowerOfAttorney}`,
  );
  const stepStatus = hasSignedDocument
    ? VerificationStatus.Completed
    : getCreationDocumentStatus(
        CompanyCreationDocumentType.PowerOfAttorney,
        context,
      );

  return {
    errors: [],
    id: State.POWER_OF_ATTORNEY,
    metadata: {
      description: {
        add: verificationRequired
          ? locales.powerOfAttorney.identityRequired
          : locales.powerOfAttorney.estimatedTime,
      },
      event: model.events.GO_POWER_OF_ATTORNEY(),
      iconName: 'receipt',
      isDisabled:
        verificationRequired ||
        stepStatus === VerificationStatus.Completed ||
        stepStatus === VerificationStatus.Validated,
      label: {
        add: locales.powerOfAttorney.label,
        review: locales.powerOfAttorney.label,
      },
    },
    status: stepStatus,
  };
};

export default getPowerOfAttorneyStep;
